import { logCritical } from '@/utils/general'

interface DeviceIntelligenceResponse {
  result: {
    session_id: string
    device_intelligence?: Record<string, unknown> | null
  }
}

export const getShieldSessionId = async () => {
  try {
    const { getShield } = useShield()
    const shield = await getShield()
    const res = (await shield.getDeviceIntelligence()) as DeviceIntelligenceResponse

    const sessionId = res.result.session_id
    const deviceIntelligence = res.result.device_intelligence

    if (!sessionId) {
      logCritical('[shield] shieldSessionId is empty or null', { context: 'getShieldSessionId', deviceIntelligence })
    }

    if (!deviceIntelligence || Object.keys(deviceIntelligence).length === 0) {
      logCritical('[shield] device_intelligence is empty or null', { context: 'getShieldSessionId', sessionId })
    }

    return sessionId
  } catch (error) {
    logCritical(
      '[shield] getDeviceIntelligence failed',
      { context: 'getShieldSessionId' },
      error instanceof Error ? error : new Error(String(error))
    )
    return null
  }
}
